import { DotChartOutlined, TableOutlined } from '@ant-design/icons';
import { useHead } from '@unhead/react';
import { Switch } from 'antd';
import { useState } from 'react';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { SteeringTableFilterData } from 'business/steering/pages/table-page';
import { SteeringGraphContainer } from 'business/steering/pages/table-page/components/chart/steering-graph-container';
import { SteeringChartFiltersProvider } from 'business/steering/providers/steering-chart-filters-provider';
import { SteeringFiltersProvider } from 'business/steering/providers/steering-filters-provider';
import { useFilterData } from 'technical/filter-data';

import { SteeringTableMobileFilters } from './steering-table-mobile-filters';
import { MobileSteeringTableWithPagination } from './steering-table-pagination';

export const MobileSteeringTable = () => {
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site');

  const { t } = useTranslation();

  const { filterData, setFilterData } =
    useFilterData<SteeringTableFilterData>();

  useHead({ title: t('user.menu.sections.steering.table.title') });

  const [showGraph, setShowGraph] = useState<boolean>(false);

  return (
    <SteeringFiltersProvider
      initialFilters={{
        filterType: 'ring',
        ringRange: [null, null],
      }}
    >
      <SteeringChartFiltersProvider
        initialFilters={{
          position: 'rear',
          scale: currentConstructionSite.tolerance,
          tolerance: currentConstructionSite.tolerance,
        }}
      >
        <MobileSingleCardPageWithFilterLayout
          title={t('steering.table.title')}
          filters={
            <SteeringTableMobileFilters
              showGraph={showGraph}
              filterData={filterData}
            />
          }
          corner={
            <Switch
              value={showGraph}
              onChange={(value) => setShowGraph(value)}
              checkedChildren={<DotChartOutlined />}
              unCheckedChildren={<TableOutlined />}
            />
          }
        >
          {showGraph ? (
            <SteeringGraphContainer setFilterData={setFilterData} />
          ) : (
            <MobileSteeringTableWithPagination setFilterData={setFilterData} />
          )}
        </MobileSingleCardPageWithFilterLayout>
      </SteeringChartFiltersProvider>
    </SteeringFiltersProvider>
  );
};
